// extracted by mini-css-extract-plugin
export default {"container":"MobileRewardsSection_container__Axrso","appIcon":"MobileRewardsSection_appIcon__ijses","appStoreCta":"MobileRewardsSection_appStoreCta__fxp-h"};